
import { GoogleGenAI } from "@google/genai";

export class GeminiService {
  private getAI() {
    return new GoogleGenAI({ apiKey: process.env.GEMINI_API_KEY });
  }

  async estimateProject(description: string) {
    try {
      const ai = this.getAI();
      // Fix: Use ai.models.generateContent with gemini-3-flash-preview for text-based analysis
      const response = await ai.models.generateContent({
        model: 'gemini-3-flash-preview',
        contents: `Act as a senior product manager at T.H.E Apps Studio. Analyze this app idea and provide a professional, enthusiastic response including: 
        1. A catchy name 
        2. A brief 2-sentence summary of why it's a great idea 
        3. 3 core features 
        4. Estimated complexity (Low/Medium/High).
        
        Idea: ${description}`,
        config: {
          temperature: 0.7,
          systemInstruction: "You are the creative lead at a boutique digital agency called T.H.E Apps Studio. Your tone is professional, innovative, and design-led."
        }
      });
      // Fix: Access response.text as a property (not a method) as per @google/genai docs
      return response.text;
    } catch (error) {
      console.error("Gemini estimation error:", error);
      return "I'd love to discuss that idea further. Let's schedule a call to dive into the specifics!";
    }
  }

  async generateImage(prompt: string) {
    try {
      const ai = this.getAI();
      // Fix: Use gemini-2.5-flash-image for default image generation tasks via generateContent
      const response = await ai.models.generateContent({
        model: 'gemini-2.5-flash-image',
        contents: {
          parts: [{ text: prompt }]
        }
      });
      
      if (response.candidates?.[0]?.content?.parts) {
        // Fix: Iterate through all parts to find the image part (inlineData)
        for (const part of response.candidates[0].content.parts) {
          if (part.inlineData) {
            return `data:${part.inlineData.mimeType};base64,${part.inlineData.data}`;
          }
        }
      }
      return null;
    } catch (error) {
      console.error("Image generation error:", error);
      return null;
    }
  }
}

export const geminiService = new GeminiService();
